var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.811 6.23-3.54-2.05c-1.34-.77-3.21-.77-4.54 0l-3.54 2.06v-.75c0-2.25 1.23-3.49 3.48-3.49h4.66c2.25 0 3.48 1.24 3.48 3.49v.74z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7 7.898-1.36-.78-2.82-1.63c-.86-.5-2.18-.5-3.04 0l-2.82 1.62-1.36.8-.18.09c-1.75 1.18-1.87 1.4-1.87 3.29v4.52c0 1.89.12 2.11 1.91 3.32l4.32 2.49c.43.26.97.37 1.52.37.54 0 1.09-.12 1.52-.37l4.36-2.52c1.76-1.18 1.87-1.39 1.87-3.29v-4.52c0-1.89-.12-2.11-1.91-3.32l-.14-.07zm-3.52 6.35c-.1.11-.17.32-.16.47l.06.96c.04.59-.38.89-.93.68l-.89-.36a.886.886 0 0 0-.51 0l-.89.35c-.55.22-.97-.09-.93-.68l.06-.96a.724.724 0 0 0-.16-.47l-.62-.74c-.38-.45-.21-.95.36-1.1l.93-.24c.15-.04.32-.18.4-.3l.52-.8c.32-.5.83-.5 1.16 0l.52.8c.08.13.26.26.4.3l.93.24c.57.15.74.65.36 1.1l-.61.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAward);
export default __webpack_public_path__ + "static/media/vuesax-bold-award.9b3917661fe33fead07de2f7618aca9c.svg";
export { ForwardRef as ReactComponent };